<template>
    <modal :name="name"
           height="95%"
           width="95%"
           scrollable
           :clickToClose="false"
           @before-open="beforeOpen"
           @before-close="beforeClose">

        <div class="container-wrap">

            <div v-if="isLoading || !dt" class="row mx-0 h-100">
                <div class="col align-self-center text-center">
                    <h5 class="text-muted">
                        Loading...
                    </h5>
                </div>
            </div>

            <div v-else class="row m-0 text-left border-bottom rounded-top bg-white p-3">
                <div class="col-8 align-self-center">
                    <span @mouseover="isHoveredDtName = true"
                          @mouseleave="isHoveredDtName = false"
                          @click="onRenameDt"
                          class="dt-name">
                        {{ dt.name | snippet(60) }}
                        <span v-show="isHoveredDtName"
                              v-tooltip="'Rename document type'"
                              class="text-primary-light font-16">
                            <i class="fa fa-pencil"></i>
                        </span>
                    </span>
                </div>
                <div class="col-4 align-self-center text-right">
                    <button v-loading.btn="isChangesSaving"
                            @click="saveChanges"
                            class="btn btn-sm btn-outline-primary"
                            style="width: 120px">
                        Save changes
                    </button>
                    <button @click="closeModal"
                            class="btn btn-sm btn-outline-info ml-3"
                            style="width: 80px">
                        Cancel
                    </button>
                </div>
            </div>

            <template v-if="!isLoading">
                <DtSettings class="options-wrap"/>
            </template>
        </div>

        <DtRename name="rename-doc-type"/>
    </modal>
</template>

<script>
import axios from 'axios'
import DtSettings from './DtSettings'
import {mapActions, mapGetters, mapMutations} from 'vuex'
import {
    DOCS_TYPES_SELECTED_SET,
    DOCS_TYPES_SELECTED_UPDATE_PROP,
    DOCS_TYPES_SET
} from '../../../../store/modules/documents'
import DtRename from './DtRename'

export default {
    name: 'DocTypeSettingsModal',
    components: {DtRename, DtSettings},
    props: {
        name: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isHoveredDtName: false,
            isLoading: false,
            isChangesSaving: false
        }
    },
    computed: {
        ...mapGetters('documents', {
            documentTypes: 'documentTypes',
            dt: 'documentTypeSelected'
        })
    },
    methods: {
        ...mapMutations('documents', {
            updateDtProp: DOCS_TYPES_SELECTED_UPDATE_PROP,
            setDocTypes: DOCS_TYPES_SET
        }),

        ...mapActions('documents', {
            setDocTypeSelected: DOCS_TYPES_SELECTED_SET
        }),

        closeModal() {
            this.$modal.hide(this.name)
        },

        beforeOpen({params}) {
            this.fetchDocType(params.uuid)
        },

        beforeClose() {
            Object.assign(this.$data, this.$options.data.apply(this))
        },

        fetchDocType(uuid) {
            this.isLoading = true
            axios.get(`documents/types/${uuid}`)
                .then(res => {
                    const dt = res.data.data
                    this.setDocTypeSelected(dt)
                })
                .catch(error => {
                    this.$snackbar.show({error})
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        async saveChanges() {
            this.isChangesSaving = true
            await this.saveDocType()
            this.isChangesSaving = false
        },

        saveDocType() {
            return axios.post(`documents/types/${this.dt.uuid}`, this.dt)
                .then(() => {
                    // update list from vuex selected dt type
                    const dtIdx = this.documentTypes.findIndex(dt => dt.uuid === this.dt.uuid)
                    if (dtIdx !== -1) {
                        const dts = _.cloneDeep(this.documentTypes)
                        dts[dtIdx] = this.dt
                        this.setDocTypes(dts)
                    }
                    this.$snackbar.show({type: 'SUCCESS', text: 'Changes saved'})
                })
                .catch(error => {
                    this.$snackbar.show({error})
                })
        },

        onRenameDt() {
            this.$modal.show('rename-doc-type', {
                dt: _.cloneDeep(this.dt),
                onSave: async name => {
                    this.updateDtProp({path: 'name', data: name})
                    await this.$nextTick()
                    await this.saveDocType()
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
    button {
        width: 140px;
    }

    .container-wrap {
        height: 100%;
        overflow-y: auto;
    }

    .options-wrap {
        height: calc(100% - 64px) !important;
        overflow-y: scroll;
    }

    .dt-name {
        display: inline-block;
        font-size: 20px;
        height: 31px;
        line-height: 31px;
        vertical-align: middle;
        font-weight: 700;
        color: $color-black-soft;
        margin-left: 16px;

        &:hover {
            cursor: pointer;
            color: $color-purple-light;
        }
    }
</style>
